import React, { useEffect, useState, useRef } from "react";
import { addNewCategory, deleteCategory, getCategories } from "../../configs/productsConfig";

function AdminNewCategory() {

    const [newCategory, setNewCategory] = useState({name: '', table: 'finished_products', image: {}});
    const [categories, setCategories] = useState([]);
    const fileInputRef = useRef(null);

    const fetchData = async () => {
        try {
            const data = await getCategories(newCategory.table);
            setCategories(data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleNewCategory = async (category) => {
    try {
        const result = await addNewCategory(category);

        if (result.success) {
            fetchData();

            setNewCategory({
                name: '',
                table: 'finished_products',
                image: {
                    url: '',
                    name: '',
                    type: '',
                }
            });

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    } catch (error) {
        console.error('Hiba a kategória hozzáadásakor:', error);
    }
};

    useEffect(() => {
        fetchData();
    }, [newCategory.table]);

   const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

        const newImage = {
            file,
            url: URL.createObjectURL(file),
            name: file.name,
            type: file.type,
        };

        setNewCategory((prevData) => ({
            ...prevData,
            image: newImage,
        }));
    };

   const handleDelete = () => {
    setNewCategory((prevData) => ({
        ...prevData,
        image: {
            url: '',
            name: '',
            type: '',
        }
    }));
    if (fileInputRef.current) {
        fileInputRef.current.value = '';
    }
};

    const handleDeleteCategory = async (index) => {
        try {
            const result = await deleteCategory(index);;

            if (result.success) {
                fetchData();
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="container-lg pt-4">

            <div className="d-flex flex-column justify-content-center align-items-center">
                <h4 className="mb-4">Kategóriák kezelése</h4>
                
                <div className="d-flex flex-row justify-content-center mb-4">
                    <input className="form-check-input" type="checkbox" value="finished_products" onChange={(e) => setNewCategory((prevData) => ({ ...prevData, table: e.target.value }))} checked={newCategory.table === "finished_products"} id="finishedProducts"></input>
                    <label className="form-check-label me-5 ms-2" htmlFor="finishedProducts">
                        Kész termék
                    </label>

                    <input className="form-check-input" type="checkbox" value="prepared_materials" onChange={(e) => setNewCategory((prevData) => ({ ...prevData, table: e.target.value }))} checked={newCategory.table === "prepared_materials"} id="preparedMaterials"></input>
                    <label className="form-check-label ms-2 me-5" htmlFor="preparedMaterials">
                        Csináld magad
                    </label>

                    <input className="form-check-input" type="checkbox" value="materials" onChange={(e) => setNewCategory((prevData) => ({ ...prevData, table: e.target.value }))} checked={newCategory.table === "materials"} id="materials"></input>
                    <label className="form-check-label ms-2" htmlFor="materials">
                        Alapanyag
                    </label>
                </div>

                <div className="form-floating mb-3 col-6">
                    <input type="text" className="form-control" id="newCategory" placeholder="" value={newCategory.name} onChange={(e)=>setNewCategory((prevData) => ({ ...prevData, name: e.target.value }))} required />
                    <label htmlFor="newCategory">Új kategória</label>
                </div>

                <div className="container-lg d-flex flex-column align-items-center mb-3">
                    <div className="col-lg-6 d-flex flex-column">
                        <h5>Képfeltöltés:</h5>
                        <input type="file" ref={fileInputRef} onChange={handleImageChange} />

                        <div className="d-flex align-items-center justify-content-center">
                            <div className={`${newCategory.image.url ? '' : 'd-none'} d-inline-block position-relative m-2`}>
                                <img src={newCategory.image.url} alt={`Uploaded image`} style={{ width: "150px" }} />
                                <button
                                    onClick={handleDelete}
                                    className="btn p-1 rounded-0 position-absolute top-0 end-0 text-white bg-primary"
                                >
                                    X
                                </button>
                            </div>
                        </div>
                        

                    </div>
                </div>
                <button className="btn btn-home-primary mb-3" onClick={() => handleNewCategory(newCategory)}>Hozzáadás</button>
            </div>

            <div className="container-lg col-md-6">
                <table className="table table-striped">
                    <tbody>
                        {categories.map((category) => (
                            <tr key={category.id}>
                                <td className="align-middle">
                                    <button className="btn" onClick={()=>handleDeleteCategory(category.id)}>X</button>
                                </td>
                                <td className="align-middle">{category.category_name}</td>
                                <td className="align-middle">
                                    <img className="rounded-circle" alt="category img" style={{width: '100px'}} src={`${category.image_path}`}/>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    )
};

export default AdminNewCategory;